import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class CompanyDepartmentGoalsRoute extends Route {
  model() {
    const department = this.modelFor('departments.department');
    return department;
  }
}

export default instrumentRoutePerformance(CompanyDepartmentGoalsRoute);
